import React from 'react';
import { Outlet } from "react-router-dom";
import { FaPersonWalkingLuggage } from "react-icons/fa6";

function Passengers() {
    return (
        <div>
            <div className="page-header h-100">
                <h1>
                    <FaPersonWalkingLuggage /> <span>Passengers</span>
                </h1>
            </div>
            <Outlet />
        </div>
    )
}
export default Passengers;